export const RI004A = {
    submitApproval: 'api/order/v2/1.0/internal/order/submit-approval',
    Jwt: {
        // provisioning
        previewOrder: 'api/reference-implementation/web-application/1.0/internal/order/ri004a/preview',
        submitOrder: 'api/reference-implementation/web-application/1.0/internal/order/ri004a/submit',
        reSubmit: 'api/reference-implementation/web-application/1.0/internal/order/ri004a/resubmit',
        internalPreviewOrder: 'api/reference-implementation/web-application/1.0/internal/preview/order',
        downloadTF: 'api/reference-implementation/web-application/1.0/internal/order',
    },
};
export default RI004A;
